/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Ai_ProvidersInputs */

const en_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI providers`)
};

const ar_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزودو الذكاء الاصطناعي`)
};

const bn_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI প্রোভাইডার`)
};

const de_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Anbieter`)
};

const es_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores de IA`)
};

const fr_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs d'IA`)
};

const pt_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores de IA`)
};

const zh_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能提供商`)
};

const tr_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI providers`)
};

const ru_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`поставщики ИИ`)
};

const pl_svchip_ai_providers = /** @type {(inputs: Svchip_Ai_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostawcy sztucznej inteligencji`)
};

/**
* | output |
* | --- |
* | "AI providers" |
*
* @param {Svchip_Ai_ProvidersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_ai_providers = /** @type {((inputs?: Svchip_Ai_ProvidersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Ai_ProvidersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_ai_providers(inputs)
	if (locale === "bn") return bn_svchip_ai_providers(inputs)
	if (locale === "de") return de_svchip_ai_providers(inputs)
	if (locale === "es") return es_svchip_ai_providers(inputs)
	if (locale === "fr") return fr_svchip_ai_providers(inputs)
	if (locale === "pt") return pt_svchip_ai_providers(inputs)
	if (locale === "zh") return zh_svchip_ai_providers(inputs)
	if (locale === "tr") return tr_svchip_ai_providers(inputs)
	if (locale === "ru") return ru_svchip_ai_providers(inputs)
	if (locale === "pl") return pl_svchip_ai_providers(inputs)
	return en_svchip_ai_providers(inputs)
});